import React, { useEffect, useState } from 'react';
interface componentProps{
    children: JSX.Element | JSX.Element[],
    onAccordionItemSelected?: (itemIndex : any, indexNumber : any)=> void,
    collectionName?: string | undefined,
    sharedValue?: string | number
}
const DEFAULT_COLLECTION_NAME = 'accordion_collection'
const JetAccordionCollection = (props: componentProps) => {
    const [selectedAccordionIndex, setSelectedAccordionIndex] = useState<String|Number>(-1)
    const currentCollectionName = props.collectionName || DEFAULT_COLLECTION_NAME
    const mapAccordionChild = (child: JSX.Element, index: Number) => {
        const newProps = { 
            expanded: (selectedAccordionIndex === `${currentCollectionName}_${index}`),
            onChange: () => {
                const newIndex = selectedAccordionIndex !== `${currentCollectionName}_${index}` ? `${currentCollectionName}_${index}` : - 1
                props.onAccordionItemSelected && props.onAccordionItemSelected(newIndex,index)
                setSelectedAccordionIndex(newIndex)
            } 
        }
        return React.cloneElement(child, newProps)
    }

    useEffect(()=> {
        if (props.sharedValue) {
            setSelectedAccordionIndex(props.sharedValue)
        }
    },[[props.sharedValue]])

    return <div className={'JetAccordionCollection'}>
        {React.Children.map(props.children, mapAccordionChild)}
    </div>
}

export default JetAccordionCollection